import { approach, hero, site } from "../utils/data";

/* The one dark section — deliberate contrast beat on an otherwise paper site. */
const Approach = () => (
  <section
    id="approach"
    className="on-ink scroll-mt-20 bg-ink-950 py-24 text-paper lg:py-32"
  >
    <div className="mx-auto max-w-shell px-6 lg:px-10">
      {/* Split header */}
      <div className="grid gap-8 border-b border-ink-800 pb-12 lg:grid-cols-12 lg:items-end lg:gap-10">
        <div className="lg:col-span-7">
          <p className="eyebrow eyebrow-dot !text-clay-light">{approach.eyebrow}</p>
          <h2 className="display mt-5 text-display-md text-paper">
            {approach.heading}
          </h2>
        </div>
        <p className="text-balance text-base leading-relaxed text-ink-300 lg:col-span-5">
          {approach.desc}
        </p>
      </div>

      {/* Numbered process — an editorial list, not a card grid */}
      <ol className="border-t border-ink-800">
        {approach.steps.map((step) => (
          <li
            key={step.num}
            className="grid gap-3 border-b border-ink-800 py-8 lg:grid-cols-12 lg:items-baseline lg:gap-10 lg:py-10"
          >
            <span className="font-mono text-micro text-ink-400 lg:col-span-1">
              {step.num}
            </span>
            <h3 className="display text-2xl tracking-tight text-paper lg:col-span-4">
              {step.title}
            </h3>
            <p className="text-base leading-relaxed text-ink-300 lg:col-span-7">
              {step.desc}
            </p>
          </li>
        ))}
      </ol>

      {/* Short-version about, folded into the same dark block */}
      <div className="mt-20 grid gap-10 lg:grid-cols-12 lg:gap-10">
        <div className="lg:col-span-4">
          {/* The portrait moved here from the hero — a printed photo on the dark wall */}
          <div className="mb-8 w-full max-w-[260px] border border-ink-800 bg-paper-100 p-2">
            <img
              src={hero.portrait}
              alt={`Portrait of ${site.name}`}
              width="900"
              height="900"
              loading="lazy"
              decoding="async"
              className="aspect-[4/5] w-full object-cover object-top grayscale"
            />
          </div>
          <p className="eyebrow eyebrow-dot !text-clay-light">{approach.aboutHeading}</p>
          <p className="display mt-5 text-display-sm text-paper">
            {site.name}
          </p>
          <p className="mt-3 font-mono text-micro uppercase text-ink-400">
            {site.role} · {site.location}
          </p>
        </div>

        <div className="space-y-6 lg:col-span-7 lg:col-start-6">
          {approach.about.map((para, i) => (
            <p
              key={i}
              className={`leading-relaxed ${
                i === 0
                  ? "text-lg text-paper sm:text-xl"
                  : "text-base text-ink-300"
              }`}
            >
              {para}
            </p>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Approach;
